import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import 'isomorphic-fetch';

interface DocumentState {
    document: DocumentData;
    loading: boolean;
}

export class RenderDocument extends React.Component<RouteComponentProps<{}>, DocumentState> {
    constructor() {
        super();
        this.state = { document: {} as DocumentData, loading: true };

        var path = window.location.pathname.substr(1);

        fetch('api/document/' + path)
            .then(response => {
                if (!response.ok) {
                    this.setState({ document: { content: 'Something went wrong' } as DocumentData, loading: false });
                    document.title = 'Error';
                }
                return response;
            })
            .then(response => response.json() as Promise<DocumentData>)
            .then(data => {
                this.setState({ document: data, loading: false });
                document.title = data.title;
            });
    }

    public render() {
        let contents = this.state.loading
            ? null
            : RenderDocument.renderDocument(this.state.document);

        return contents;
    }

    private static renderDocument(document: DocumentData) {

        return <div className='document-container' dangerouslySetInnerHTML={{ __html: document.content }}></div>;
    }
}

interface DocumentData {
    documentId: number;
    versionStamp: string;
    title: string
    content: string;
    summary: string;
    author: string;
}



// WEBPACK FOOTER //
// ./ClientApp/components/RenderDocument.tsx